import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Link,
  Modal,
  ModalTrigger,
  PrimaryButton,
} from "@certn/cascadia-react";
import { ReactNode } from "react";
import { Trans } from "react-i18next";

type ModalProps = {
  link: string;
  header: string;
  content: string | ReactNode;
};

export function IncomeVerificationBaseModal(props: ModalProps) {
  const { link, content, header } = props;

  return (
    <ModalTrigger
      trigger={
        <Link
          testID="income-verification-learn-more-modal-link"
          linkStyle="monochrome"
        >
          {link}
        </Link>
      }
    >
      <Modal>
        <Dialog>
          {({ close }) => (
            <>
              <DialogHeader>{header}</DialogHeader>
              <DialogContent>{content}</DialogContent>
              <DialogFooter>
                <PrimaryButton onPress={close}>
                  <Trans>Close</Trans>
                </PrimaryButton>
              </DialogFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}
